import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NotificationParse} from "../../../ParseClass/notificationParse";
import {NotificationStates} from "../../../providers/service/notifications.service";
import {arrayIsSet, getOnlyValuesEnum, stringIsSet} from "../../../providers/service/global-variables.service";
import {UserService} from "../../../providers/service/user.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {AlertService} from "../../../providers/service/alert.service";

@Component({
    selector: 'app-notifications-details',
    templateUrl: './notifications-details.component.html',
    styleUrls: ['./notifications-details.component.scss'],
    standalone: false
})
export class NotificationsDetailsComponent {
    possibleValues = getOnlyValuesEnum(NotificationStates)
    form: FormGroup
    loadingUser = false;
    users: { objectId: string, nome: string }[] | undefined = undefined;
    isEditable: boolean

    constructor(
        public dialogRef: MatDialogRef<NotificationsDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            notification: NotificationParse,
            users: string[] | undefined,
            isEditable: boolean | undefined
        },
        private userService: UserService,
        private ts: TranslateService,
        private alertService: AlertService,
        fb: FormBuilder
    ) {
        this.form = fb.group({userAssignTo: undefined})
        this.isEditable = this.data.isEditable == true
    }

    markRead() {
        this.dialogRef.close({markHasRead: true})
    }

    takeACharge() {
        this.dialogRef.close({state: NotificationStates.IN_CARICO})
    }

    complete() {
        this.dialogRef.close({state: NotificationStates.COMPLETATO})
    }


    openAssignedTo() {
        if (arrayIsSet(this.data.users)) {
            this.loadingUser = true
            this.userService.getUserDetail(this.data.users).subscribe((users: any[]) => {
                if (arrayIsSet(users)) {
                    this.users = users.map((user: any) => {
                        let name = '';
                        if (user.attributes) {
                            if (user.attributes.name) {
                                name += user.attributes.name
                            }
                            if (user.attributes.surname) {
                                if (stringIsSet(name)) {
                                    name += ' '
                                }
                                name += user.attributes.surname
                            }
                        }
                        if (!stringIsSet(name)) {
                            name = user.id
                        }
                        return {objectId: user.id, nome: name}
                    })
                }
                this.loadingUser = false
            })
        } else {
            this.alertService.warning(this.ts.instant('noUserInProject'))

        }
        // this.dialogRef.close({state: NotificationStates.IN_CARICO, user: undefined})
    }

    assignTo() {
        if (arrayIsSet(this.form.get('userAssignTo')?.value)) {
            this.dialogRef.close({state: NotificationStates.IN_CARICO, userId: this.form.get('userAssignTo')?.value[0]})
        } else {
            this.alertService.warning(this.ts.instant('noUserSelected'))
        }
    }

    archive() {
        this.dialogRef.close({state: NotificationStates.ARCHIVIATO})
    }
}
